export const appEnv = {
  cognito: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  },
};
